import { distributionAreaOptions } from "@nano-portal/customers"
import {} from "@radix-ui/react-select"
import { ForwardedRef, forwardRef } from "react"
import { FormSelect, FormSelectProps } from "./Select"

type Props = Omit<FormSelectProps<typeof distributionAreaOptions>, "label" | "required" | "placeholder" | "options">

function DistributionAreaSelectRaw(props: Props, ref: ForwardedRef<HTMLSelectElement>) {
  const { id, ...rest } = props

  return (
    <FormSelect
      id={id}
      ref={ref}
      options={distributionAreaOptions}
      placeholder="Vyberte distribuční oblast"
      required
      {...rest}
    />
  )
}

export const DistributionAreaSelect = forwardRef(DistributionAreaSelectRaw)
